import React from 'react';
import loadable from '@loadable/component';
import { NullLoader } from '@qover/molecules';

export const BikeQuote = loadable(() => import('./BikeQuote'), {
  fallback: <NullLoader />,
});
